import { useEffect, useState } from "react"
import { useSelector } from "react-redux"

import LiabilityItem from "./LiabilityItem"
import LiabilityNoItems from "./LiabilityNoItems"

import classes from '../Shared/Container.module.css'

const LiabilityDetails = () => {

    const activeCase = useSelector(state => state.case.activeCase)         


    const [liabilityData, setLiabilityData] = useState(null)

    useEffect(() => {
        if (activeCase) {
            let arr = [...activeCase.liabilities].sort(function(x, y) {
                return ((x.active == y.active) ? 0 : x.active ? -1 : 1);
            });

            let arr2 = arr.sort(function(x, y) {
                return ((x.is_primary_insurance == y.is_primary_insurance) ? 0 : x.is_primary_insurance ? -1 : 1)
            });
      
            setLiabilityData(arr2)
        }
    }, [activeCase])

    return <div className={classes.container}>
        <LiabilityNoItems permissionType={'case_liability'}/>

        {liabilityData && liabilityData.map((item, index) => (
            <LiabilityItem key={item.id} data={item} lastChild={index == liabilityData.length-1} apiCase={'case_liability'}/>
        ))}

        
    </div>
}

export default LiabilityDetails